import {
  Boxes,
  Calculator,
  ChartLine,
  Leaf,
  PenTool,
  Recycle,
  ScanSearch,
  Truck,
  Container,
  CalendarClock,
  type LucideIcon,
} from "@/components/icons";
import type { ToolId } from "@/lib/tools/catalog";

export const TOOL_ICONS: Record<ToolId, LucideIcon> = {
  "pallet-roi": Calculator,
  "gaylord-volume": Boxes,
  "sustainability-impact": Leaf,
  "diversion-savings": Recycle,
  "pickup-frequency": CalendarClock,
  "truck-loading": Container,
  "freight-calculator": Truck,
  "packaging-designer": PenTool,
  grade: ScanSearch,
  "price-index": ChartLine,
};
